import { generatePathname } from '@/helpers/generatePathname';
import { Avatar } from '@mui/material';
import { PATH_NAME } from 'configs/pathName';
import { newTimeStamp } from '../../../common/timestamp';
import { DEFAULT_AVT_IMG } from '../../../constant/imgImport';
import { ROLE_ACCESS } from '../../../constant/storage';
import { ICommentUserInfo } from '../../../interfaces/components/comment.interface';
import BlueTick from '../../elements/profile/BlueTick';

interface ICommentCardUser {
  userInfo: ICommentUserInfo;
  commentDate: string;
  badge: React.ReactNode | React.ReactNode[];
  commentCardMenu: React.ReactElement;
}

const CommentCardUser = ({
  userInfo,
  commentDate,
  badge,
  commentCardMenu,
}: ICommentCardUser) => {
  const profilePathname = generatePathname({
    pathname: PATH_NAME.PROFILE,
    query: {
      uid: userInfo.owner.ownerId,
    },
  });

  return (
    <div className="flex items-center justify-between gap-1">
      <div className={`flex items-center gap-1`}>
        <a
          href={profilePathname}
          target="_blank"
          className="cursor-pointer"
          rel="noreferrer"
        >
          <Avatar
            sx={{ width: 36, height: 36, bgColor: '#009CE0' }}
            src={userInfo?.avatar || DEFAULT_AVT_IMG}
          />
        </a>
        <div className="flex flex-col justify-between">
          {userInfo.isOwnerCommentAuthorPost === ROLE_ACCESS.Owner && (
            <span className="text-[10px] font-semibold leading-[15px] text-grey_helper">
              Tác giả
            </span>
          )}
          <a
            href={profilePathname}
            target="_blank"
            className="flex items-center"
            rel="noreferrer"
          >
            <p className="text-sm font-semibold">
              {userInfo.academicRank && <>{userInfo.academicRank}. </>}
              {userInfo.fullName}
            </p>
            {userInfo?.hasBlueTick && (
              <div className="ml-1">
                <BlueTick width={20} height={20} />
              </div>
            )}
          </a>
        </div>
        <span className="ml-2 text-xs font-medium leading-[18px] text-grey_helper">
          {newTimeStamp(commentDate)}
        </span>
        {badge && badge}
      </div>

      <div className="hidden lg:block">{commentCardMenu}</div>
    </div>
  );
};

export default CommentCardUser;
